export const URL = "https://dcb.noeticworld.com";
